// Indian Rupee currency formatting for HITÉRA
export const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;
